import EvaluationESIIScreen from "../partialScreens/ActivityDetails/EvaluationESIIScreen";
import EvaluationSummaryScreen from "../partialScreens/ActivityDetails/EvaluationSummaryScreen";
import { FormLoader } from "../../utils/Loader";

const EvaluationScreen = (props) => {
  const { isFetching, activityHistoryAllInfo, dashboard } = props;

  if (isFetching) {
    return (
      <div className="text-center">
        <FormLoader width={800} />
      </div>
    );
  }

  if (!activityHistoryAllInfo) {
    return <div className="p-3 text-center">No data available</div>;
  }

  return dashboard === "ESII" ? (
    <EvaluationESIIScreen {...props} />
  ) : (
    <EvaluationSummaryScreen {...props} />
  );
};

export default EvaluationScreen;
